import React from 'react';
import { Box } from '@chakra-ui/react';
import { ChevronDown20, CarbonIconType } from '@carbon/icons-react';
import { SidebarButton } from './SidebarTriggers';

interface SidebarGroupProps {
  icon: CarbonIconType;
  label: string;
  isOpen: boolean;
  userIsWithin: boolean;
  handleToggle: React.Dispatch<React.SetStateAction<string | null>>;
}

const SidebarGroup: React.FC<SidebarGroupProps> = ({
  children,
  icon,
  label,
  isOpen,
  userIsWithin,
  handleToggle,
}) => {
  const onClick = () => {
    handleToggle(!isOpen ? label : null);
  };

  return (
    <Box
      as="li"
      listStyleType="none"
      position="relative"
      bg={isOpen || userIsWithin ? 'gray.800' : 'initial'}
    >
      <Box position="relative">
        <SidebarButton
          icon={icon}
          onClick={onClick}
          _before={{
            content: `""`,
            position: 'absolute',
            top: 0,
            left: 0,
            h: '100%',
            width: userIsWithin && !isOpen ? 1 : 0,
            bg: 'yellow.400',
            transition: '.1s width ease-in',
          }}
        >
          {label}
        </SidebarButton>
        <Box
          as={ChevronDown20}
          position="absolute"
          transition=".2s transform ease-out"
          transform={`translateY(-50%) rotate(${isOpen ? 180 : 0}deg)`}
          top="50%"
          right={0}
          marginRight={4}
          color="gray.800"
          pointerEvents="none"
        />
      </Box>
      {isOpen && children}
    </Box>
  );
};

export default SidebarGroup;
